import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const CarrierLogo = styled.img`
  height: ${props => props.theme.size.S};
`
